// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SideBar_mainContainer__34CMT","logoContainer":"SideBar_logoContainer__pAWLo","navContainer":"SideBar_navContainer__3OJGr"};